import React, { PropTypes } from 'react';

import './PageBlock.scss';

const PageBlock = props => <div className="page-block">{props.children}</div>;

export default PageBlock;
